export enum ScreenOrigin {
  HOME = 'home',
  SEARCH = 'search',
}
